import Snappy from '../snappy/snappy';
import $ from 'jquery';

const OptaService = {

  init() {
    this.addEventListeners();
  },

  addEventListeners() {
    if (window.Opta) {
      window.Opta.events.subscribe('widget.drawn', this.onOptaWidgetRendered.bind(this));
      window.Opta.events.subscribe('widget.error', this.onOptaWidgetError.bind(this));
    }
  },

  onOptaWidgetRendered(optaObj) {
    this.broadcastEventToFAComponent(optaObj.widget);
  },

  onOptaWidgetError(optaObj) {
    this.broadcastEventToFAComponent(optaObj.widget, true);
  },

  broadcastEventToFAComponent(widget, isError) {
    const faComponent = document.querySelector(`[data-uid="${widget.attr.uid}"]`);

    faComponent.component.onOptaDataReceived(widget, isError);
  }
};

export default OptaService;



// WEBPACK FOOTER //
// ./libs/optaService/optaService.js